module.exports = __webpack_public_path__ + "img/map-4-f.6a7889f8.png";